{
  "labels": {
    "textSingleLine": "텍스트 - 한 줄",
    "textMultipleLines": "텍스트 - 여러 줄",
    "date": "날짜",
    "trueFalse": "참/거짓",
    "singleDocument": "단일 문서",
    "multiDocument": "다중 문서",
    "number": "숫자",
    "eMail": "이메일",
    "phone": "전화번호",
    "dropDownSingleSelectList": "드롭다운 단일 선택 목록",
    "dropDownMultiSelectList": "드롭다운 다중 선택 목록",
    "comboBox": "콤보 상자",
    "timestamp": "타임스탬프",
    "featureLink": "기능 링크"
  },
  "descriptions": {
    "openTextFieldSingleLine": "자유 입력 텍스트 필드, 한 줄",
    "openTextFieldMultipleLines": "자유 입력 텍스트 필드, 여러 줄",
    "formatMmDdYyyy": "형식 MM/DD/YYYY",
    "toggleButton": "토글 버튼",
    "singleFileUploadField": "단일 파일 업로드 필드",
    "multipleFileUploadField": "다중 파일 업로드 필드",
    "numericInputField": " 숫자 입력 필드",
    "emailAddressInputField": "이메일 주소 입력 필드",
    "format1XxxXxxXxxx": "형식 +1(XXX) XXX-XXXX",
    "selectOneOptionFromAList": "목록에서 옵션 하나 선택",
    "selectMultipleOptionsFromAList": "목록에서 여러 옵션 선택",
    "singleOptionDropDownListOpenTextField": "단일 선택 드롭다운 목록 + 자유 입력 텍스트 필드",
    "dateAndTimeFields": "날짜 및 시간 필드",
    "linkToTheFormFeatures": "양식 기능 링크"
  }
}
